import React, { useState, useEffect } from 'react';
import AnimeCardComponent from './animecard/AnimeCardComponent';
import AnimeRow from './AnimeRow';
import mindIcon from '../assets/ic_mind.svg';
import YandexAdComponent from './YandexAdComponent';
import adBackgroundImage from '../assets/ad_placeholder.png';
import adAska from '../assets/ad_aska.png';
import adHq from '../assets/ad_quality.png';
import adPop from '../assets/ad_pop.png';
import adRei from '../assets/ad_rei.png';
import AnimixPremiumPopup from './premium/AnimixPremiumPopup';
// Utility function to get a random title from a list
const getRandomTitle = (titles) => {
    return titles[Math.floor(Math.random() * titles.length)];
};

const RecommendationsComponent = ({ recs }) => {
    // Define title lists for each category
    const categoryTitles = ["Категория", "Специально для Вас", "Выбор редакции"];
    const neuralTitles = ["Нейронные рекомендации", "Персональная рекомендация", "ИИ советует", "Специально для Вас"];
    const popularTitles = ["Популярные", "Тренды", "Лидеры просмотров"];
    const viralTitles = ["Вирусные", "Топ на этой неделе", "Много смотрят"];
    const ratingTitles = ["Лучший рейтинг", "Топ по оценкам", "Высоко оцененные"];
    const hqTitles = ["Аниме в 4К и 2К", "Высокое качество", "Эксклюзивно в 2К и 4К"];
    const urTitles = ["Топ по оценкам пользователей", "Анимиксовцы рекомендуют", "Зрительские симпатии"];
    const [showSubscribePopup, setShowSubscribePopup] = useState(false);

    const [showAdBlock, setShowAdBlock] = useState(false); // State to control ad visibility

    // State to store random titles for each section
    const [randomTitles, setRandomTitles] = useState({
        category: '',
        neural: '',
        popular: '',
        viral: '',
        rating: '',
        hq: '',
    });

    // Define ad objects with image, title, text, and link
    const ads = [
        {
            title: "Отключите рекламу",
            text: "Наслаждайтесь просмотром аниме без рекламы",
            image: adAska,
            link: "premium" // This will trigger the premium popup
        },
        {
            title: "Настройте рекомендации",
            text: "Получите персональные рекомендации, настроенные под ваши предпочтения.",
            image: adBackgroundImage,
            link: "premium" // This will trigger the premium popup
        },
        // {
        //     title: "Наш VPN",
        //     text: "Высокие скорости и соврмеменные протоколы",
        //     image: adVpn,
        //     link: "https://play.google.com/store/apps/details?id=ru.oig.etyvpn" // This will openч in a new tab
        // },
        {
            title: "Смотрите аниме в 4К и 2К",
            text: "Невероятная чёткость специально для вас, эксклюзивно на animix",
            image: adHq,
            link: "premium" // This will openч in a new tab
        },
        {
            title: "На ПК - сайт, на телефон - прилка",
            text: "Удобный плеер, более стабильная и быстрая работа",
            image: adPop,
            link: "https://play.google.com/store/apps/details?id=lol.animix.app" // This will open in a new tab
        },
        {
            title: "Новости, конкурсы и аниме-чатик",
            text: "Всё это про наш Telegram. Уютное место для людей, которые любят аниме",
            image: adRei,
            link: "https://t.me/animixlib" // This will open in a new tab
        }
    ];

    // Utility function to get a random item from an array
    const getRandomItem = (items) => {
        return items[Math.floor(Math.random() * items.length)];
    };

    const [randomAd, setRandomAd] = useState(null);

    useEffect(() => {
        // Set a random ad on mount
        setRandomAd(getRandomItem(ads));
    }, []); // Empty dependency array ensures this effect runs only once

    const handleAdClick = (ad) => {
        if (ad.link === "premium") {
            setShowSubscribePopup(true); // Show premium popup
        } else {
            window.open(ad.link, "_blank"); // Open external link in new tab
        }
    };

    // Generate random titles once when component mounts
    useEffect(() => {
        setRandomTitles({
            category: getRandomTitle(categoryTitles),
            neural: getRandomTitle(neuralTitles),
            popular: getRandomTitle(popularTitles),
            viral: getRandomTitle(viralTitles),
            rating: getRandomTitle(ratingTitles),
            hq: getRandomTitle(hqTitles),
            userRating: getRandomTitle(urTitles),
        });

        // Random chance to show ad block (e.g., 30% chance)
        if (Math.random() < 0.3 && localStorage.getItem("subscribed") != "true") {
            setShowAdBlock(true);
        }
    }, []); // Empty dependency array ensures this effect runs only once

    return (
        <div>
            {recs.CATEGORY && (
                <AnimeRow
                    eyebrow="Категория"
                    title={recs.CATEGORY.name}
                    items={recs.CATEGORY.animeList}
                    to={`/category/${recs.CATEGORY.id}`}
                />
            )}

            {recs.NEURAL && (
                <AnimeRow
                    eyebrow="Оставляйте позитивные оценки, чтобы улучшить подборку"
                    title={randomTitles.neural}
                    icon={mindIcon}
                    items={recs.NEURAL}
                />
            )}

            {recs.HQ && <AnimeRow title={randomTitles.hq} items={recs.HQ} />}

            {recs.POPULAR && <AnimeRow title={randomTitles.popular} items={recs.POPULAR} />}

            {recs.REVIEW && recs.REVIEW.reviewEntity != null ? (
                <div className="review-container">
                    <div className="review-header">


                        <AnimeCardComponent key={recs.REVIEW.animeEntity.id} anime={recs.REVIEW.animeEntity} isInteractive={true} />

                        <div className="review-body">
                            <div className="anime-stars">
                                {Array(recs.REVIEW.reviewEntity.stars).fill('★')}
                            </div>
                            <h3 className="rec-review-message">{recs.REVIEW.reviewEntity.message}</h3>
                            <p className="rec-anime-name">{recs.REVIEW.animeEntity.name}</p>
                            <label>Отзыв пользователя</label>
                        </div>
                    </div>

                </div>
            ) : ''}


            {recs.VIRAL && <AnimeRow title={randomTitles.viral} items={recs.VIRAL} />}

            {recs.RATING && <AnimeRow title={randomTitles.rating} items={recs.RATING} />}

            {recs.USER_RATING && <AnimeRow title={randomTitles.userRating} items={recs.USER_RATING} />}

            <div className="container-wrapper"> <YandexAdComponent blockId="R-A-8131234-2" /> </div>

            {showAdBlock && randomAd && (
                <div className="full-width-da-block">
                    <img src={randomAd.image} alt="Ad Background" />
                    <h2 className="da-title">{randomAd.title}</h2>
                    <p className="da-text">{randomAd.text}</p>
                    <button className="da-button" onClick={() => handleAdClick(randomAd)}>
                        Узнать больше
                    </button>
                </div>
            )}

            {showSubscribePopup && (
                <AnimixPremiumPopup onClose={() => setShowSubscribePopup(false)} />
            )}
        </div>
    );
};

export default RecommendationsComponent;
